import { GetDoctorRequestPayload } from "@/data/payload/admin/get-doctor-request-payload";
import { DoctorDetailInfoEntity } from "@/domain/entity/admin/doctor-detail-info-entity";
import { AdminRepository } from "@/domain/repository/admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchDoctorUsecase {
  constructor(private readonly adminRepository: AdminRepository) {}

  async execute(doctorUuid: string): Promise<SATResult<DoctorDetailInfoEntity, SATError>> {
    const payload: GetDoctorRequestPayload = {
      doctorUuid: doctorUuid,
    };
    const result = await this.adminRepository.fetchDoctor(payload);

    if (result.isSuccess) {
      return SATResult.success(result.value);
    }

    return SATResult.failure(result.error);
  }
}
